export default "__VITE_ASSET__CAsjR8BT__"